/*
 *  Copyright (C) 2019 schroeder.org - All Rights Reserved
 *  Unauthorized copying of this file or deriving works therefrom,
 *  via any medium, is strictly prohibited
 *  Proprietary and confidential
 *  <dev@schroeder.org>
 */

enum QuizCommand {
  Play = 'play',
  Check = 'check',
  Skip = 'skip',
  Previous = 'previous',
}

export default QuizCommand;
